export default __webpack_public_path__ + "5d533615d89f53784fe6ed661fb73849.png";